module.exports = __webpack_public_path__ + "static/52-8b9dcc14f95ae69a3be6541ae0e7ab9e.png";